import { NodeEventTypes } from './node-event-types';

export class NodeEvent {
    public constructor(
        public type: NodeEventTypes,
        public data: object = null
    ) {}
}
